import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-free-trial-style-two',
  templateUrl: './free-trial-style-two.component.html',
  styleUrls: ['./free-trial-style-two.component.scss']
})
export class FreeTrialStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
